import { Trans } from '@mbarzda/solid-i18next'
import { type Component } from 'solid-js'
import Instagram from '../../../assets/images/ic_instagram.svg'
import TikTok from '../../../assets/images/ic_tiktok.svg'
import Twitter from '../../../assets/images/ic_twitter.svg'
import Youtube from '../../../assets/images/ic_youtube.svg'
import Logo from '../../../assets/images/profittree-logo.svg'

const Footer: Component = () => {
  return (
    <div class="flex flex-col w-full bg-gray-50 text-xs text-gray-500 text-center sm:text-left border-t border-t-gray-200">
      <div class="flex flex-col gap-6 sm:flex-row px-4 sm:px-10 py-10 justify-between items-center">
        <div class="flex flex-col gap-4 items-center sm:items-start">
          <img src={Logo} class="w-[162px]" alt="ProfitTree"/>
          <span>The secret tool to grow your marketplace without headaches.</span>
          <span>ProfitTree Ltd<br/>Evagora Pallikaridi 38<br/>8010 Paphos, CYPRUS</span>
          <span>Managing Director: Nikolas Konstantinou<br/>Registration Number: HE 455602</span>
          <span>Email: admin@profittree.io</span>
        </div>
        <div class="flex gap-6">
          <a target="_blank" href="https://www.youtube.com/channel/UCpssraT8Nn8Q8SB9-DUVvCQ"><img class="w-6 h-6" src={Youtube} alt="Youtube"/></a>
          <a target="_blank" href="https://www.instagram.com/profittree/"><img class="w-6 h-6" src={Instagram} alt="Instagram"/></a>
          <a target="_blank" href="https://www.tiktok.com/@profittree.io"><img class="w-6 h-6" src={TikTok} alt="TikTok"/></a>
          <a target="_blank" href="https://x.com/ProfitTree_io"><img class="w-6 h-6" src={Twitter} alt="X"/></a>
        </div>
      </div>
      <div class="flex px-4 sm:px-10 flex-col sm:flex-row border-t border-gray-200 py-4 justify-start items-center text-center sm:text-left gap-2">
        <span>2025 © ProfitTree. All Rights Reserved</span>
        <div>
          <a href="https://profittree.io/terms-and-conditions" class="underline">
            <Trans key="ls_footer_terms_and_conditions"/>
          </a> | <a href="https://profittree.io/privacy-policy" class="underline">
            <Trans key="ls_footer_privacy_policy"/>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer
